<!--
* UIID: UI-DLB-MBL-100
* UI Name: Map Builder
* Modify Date: 2020/07/15
-->

<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12" lg="2" md="2">
        <v-toolbar-title class="font-bold">{{ $t('lbl.mapBuilder.pageHeader') }}</v-toolbar-title>
      </v-col>
      <!-- 2022.01.13 213960 SPKA-365 Modify light version for Map Builder -->
    </v-row>
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="pt-0 pb-0 pl-0">
        <v-col
          class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
          cols="12"
          lg="2"
          md="6"
        >
          <v-autocomplete
            v-model="scannerType"
            :items="fileType"
            dense
            class="custom-selectbox"
            @change="changeType"
            filled
            label="File type"
          ></v-autocomplete>
        </v-col>
      </v-col>
    </v-row>
    <!-- Tab control -->
    <v-row class="page-tab">
      <v-col class="pt-0" cols="12">
        <v-tabs v-model="tab" class="custom-tab-bar" background-color="primary">
          <v-tab :class="[$vuetify.theme.dark ? 'mr-1' : '']" v-for="item in items" :key="item.tab">
            {{ item.content }}
          </v-tab>
        </v-tabs>

        <v-tabs-items class="custom-tab-content" v-model="tab">
          <v-tab-item no-animation :key="'scanner'">
            <Scanner
              :key="scannerCompo"
              :scannerType="scannerType"
              :versionList="scannerVersionHistoryItem"
              @openLoadFile="openLoadFile($event)"
              @openScannerListDialog="openScannerListDialog($event)"
              @openScannerLayoutCheckIn="openScannerLayoutCheckIn($event)"
              @changeScannerVersionHistoryItem="changeScannerVersionHistoryItem($event)"
              ref="scanner"
            >
            </Scanner>
          </v-tab-item>
          <v-tab-item no-animation :key="'mapper'">
            <Mapper
              :key="mapperCompo"
              :scannerType="scannerType"
              :versionList="flatFileVersionHistoryItem"
              @openLoadFile="openLoadFile($event)"
              @openMapperListDialog="openMapperListDialog($event)"
              @openCodeTableDialog="openCodeTableDialog($event)"
              @openMapperLayoutCheckIn="openMapperLayoutCheckIn($event)"
              @changeMapperVersionHistoryItem="changeMapperVersionHistoryItem($event)"
              ref="mapper"
            >
            </Mapper>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="load-file-dialog"
      >
      </load-file-dialog>
      <scannerList
        v-if="dialog.type == 'scannerList'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openScannerVersion="openScannerVersion($event)"
        ref="scannerList"
        class="maplist-layout-dialog"
      >
      </scannerList>
      <selectCodeList
        v-if="dialog.type == 'selectCodeList'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openScannerVersion="openScannerVersion($event)"
        @selectCodeItem="selectCodeItem($event)"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        ref="selectCodeList"
      >
      </selectCodeList>
      <mapperList
        v-if="dialog.type == 'mapperList'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openMapperVersion="openMapperVersion($event)"
        class="maplist-layout-dialog"
        ref="mapperList"
      >
      </mapperList>
      <scannerCheckIn
        v-if="dialog.type == 'scannerCheckIn'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :scannerType="scannerType"
        :move="dialogDragEnd"
        :options="dialog.options"
        :versionList="scannerVersionHistoryItem"
        @openScannerVersionSave="openScannerVersionSave($event)"
        class="custom-dialog mapper-version"
      >
      </scannerCheckIn>
      <mapperCheckIn
        v-if="dialog.type == 'mapperCheckIn'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :scannerType="scannerType"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :versionList="flatFileVersionHistoryItem"
        @openCodeTableDialog="openCodeTableDialog($event)"
        @openMapperVersionSave="openMapperVersionSave($event)"
        class="custom-dialog mapper-version"
        ref="mapperBuilderCheckIn"
      >
      </mapperCheckIn>
      <mapper-version-dialog
        v-if="dialog.type == 'mapperVersion'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshMapVersion"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        @closeMapperListDialog="closeMapperListDialog($event)"
        class="custom-dialog mapper-version"
        ref="mapperVersion"
      >
      </mapper-version-dialog>
      <mapper-version-save-dialog
        v-if="dialog.type == 'mapperVersionSave'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshMapVersion"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></mapper-version-save-dialog>
      <scanner-version-dialog
        v-if="dialog.type == 'scannerVersion'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshScannerVersion"
        :versionList="scannerVersionHistoryItem"
        :options="dialog.options"
        @closeScannerListDialog="closeScannerListDialog($event)"
        class="custom-dialog mapper-version"
        ref="scannerVersion"
      >
      </scanner-version-dialog>
      <scanner-version-save-dialog
        v-if="dialog.type == 'scannerVersionSave'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshMapVersion"
        :versionList="scannerVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></scanner-version-save-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import loadFileDialog from '@/vue-dlb/views/mapbuilder/LoadFile.vue';
import Mapper from './Mapper.vue';
import Scanner from './Scanner.vue';
import mapperList from '@/vue-dlb/views/mapbuilder/MapperList.vue';
import scannerList from '@/vue-dlb/views/mapbuilder/ScannerList.vue';
import selectCodeList from '@/vue-dlb/views/commons/SelectCodeTable.vue';
import scannerCheckIn from '@/vue-dlb/views/mapbuilder/ScannerCheckIn.vue';
import mapperCheckIn from '@/vue-dlb/views/mapbuilder/MapperCheckIn.vue';
import mapperVersionDialog from '@/vue-dlb/views/mapbuilder/MapperVersionHistory.vue';
import scannerVersionDialog from '@/vue-dlb/views/mapbuilder/ScannerVersionHistory.vue';
import mapperVersionSaveDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue';
import scannerVersionSaveDialog from '@/vue-dlb/views/map/ScannerVersionHistory.vue';

import cfg from '@/vue-caas/config/config.js';

export default {
  components: {
    Mapper,
    Scanner,
    loadFileDialog,
    scannerList,
    mapperList,
    scannerCheckIn,
    mapperVersionDialog,
    scannerVersionDialog,
    mapperCheckIn,
    selectCodeList,
    mapperVersionSaveDialog,
    scannerVersionSaveDialog,
  },
  computed: {
    ...mapState('mapbuilder', {
      movedata: 'movedata',
      mapList: 'mapList',
    }),
    ...mapState('map', {
      mapperList: 'mapperList',
      scannerList: 'scannerList',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
    }),
    ...mapState('codetable', {
      codetables: 'codetables',
    }),
  },
  data: () => ({
    codeCtg: '',
    mapperCompo: 0,
    scannerCompo: 0,
    arrLayoutDialog: [],
    dialogs: [],
    dialogId: 1,
    tab: null,
    scannerType: 'FTE',
    items: [
      { tab: 'scanner', content: 'Scanner' },
      { tab: 'mapper', content: 'Mapper' },
    ],
    //203665 2020-10-09 CLV Change selectbox data [issue 26 MapBuilder]
    fileType: [
      { text: 'EDI', value: 'ediscanner' },
      { text: 'X12', value: 'ediscanner_x12' },
      { text: 'JSON', value: 'jsonscanner' },
      { text: 'XML', value: 'xmlscanner' },
      { text: 'FlatFile', value: 'FTE' },
    ],
    flatFileVersionHistoryItem: null,
    scannerVersionHistoryItem: null,
    pendingScannerItem: null,
    scannerData: [],
    codetableItems: {
      header: ['CUST_ID', 'OWNR_CUST_ID'],
      data: [
        {
          CUST_ID: '',
          OWNR_CUST_ID: '',
        },
      ],
    },
    versionHistoryItems: {
      header: ['MAP_PRCS_NO'],
      data: [
        {
          MAP_PRCS_NO: '',
        },
      ],
    },
    masterSearchItems: {
      header: ['ADMIN_YN', 'CUST_ID', 'LOCK_YN', 'MAP_PRCS_NO'],
      data: [
        {
          ADMIN_YN: '',
          CUST_ID: '',
          LOCK_YN: '',
          MAP_PRCS_NO: '',
        },
      ],
    },
  }),
  async created() {
    this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
    if ($cookies.get('comp-id') == cfg.provider) {
      //only available for CLT Company, Super Admin
      this.masterSearchItems.data[0].CUST_ID = 'ALL'; // TBD - April. After get API from CASS to search customer, Change here.
    } else {
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
    }
    this.masterSearchItems.data[0].LOCK_YN = '';
    this.masterSearchItems.data[0].MAP_PRCS_NO = '';
    await Store.dispatch('mapbuilder/queryMapList', this.masterSearchItems);

    this.changeMap();
  },
  watch: {
    '$route.query': {
      handler() {
        this.changeMap();
      },
      deep: true,
      immediate: true,
    },
    tab(val) {
      if (val === 0) {
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.pendingScannerItem) {
              this.$refs.scanner.updateScanner(this.pendingScannerItem);
              this.$refs.scanner.updateScannerStatus('Y');
              this.pendingScannerItem = null;
            }
          });
        }, 300);
      }
    },
  },

  methods: {
    getCodetables(data) {
      this.codetableItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codetableItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      Store.dispatch('codetable/codetables', this.codetableItems).then(() => {
        this.codetables.forEach((item) => {
          if (data === item.CODE_CTG_ID) {
            this.selectCodeItem(item);
          }
        });
      });
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerListDialog(selectItem) {
      let type = 'scannerList';
      let item = {
        ROWID: 0,
        item: selectItem,
      };
      let indexArrDialog = this.findDialog('scannerList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openCodeTableDialog(codeCtg) {
      let type = 'selectCodeList';
      let item = {
        ROWID: 0,
        codeCtg: this.codeCtg,
      };
      let indexArrDialog = this.findDialog('selectCodeList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperListDialog(selectItem) {
      let type = 'mapperList';
      let item = {
        ROWID: 0,
        item: selectItem,
      };
      let indexArrDialog = this.findDialog('mapperList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerLayoutCheckIn(data) {
      let type = 'scannerCheckIn';
      let item = {
        ROWID: 0,
        action: 'scannerBuilder',
        data: data,
      };
      let indexArrDialog = this.findDialog('scannerCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperLayoutCheckIn(data) {
      let type = 'mapperCheckIn';
      let item = {
        ROWID: 0,
        action: 'mapperBuilder',
        data: data,
      };
      let indexArrDialog = this.findDialog('mapperCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperVersion(itemRow) {
      this.codeCtg = itemRow.CODE_CTG_ID;
      let type = 'mapperVersion';
      let item = {
        ROWID: 0.5,
        action: 'mapbuilder',
        codeName: itemRow.CODE_CTG_NAME,
        codeId: itemRow.CODE_CTG_ID,
        data: itemRow,
      };
      this.flatFileVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('mapperVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerVersion(itemRow) {
      let type = 'scannerVersion';
      let item = {
        ROWID: 0,
        action: 'scannerbuilder',
        data: itemRow,
      };
      this.scannerVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('scannerVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperVersionSave() {
      let type = 'mapperVersionSave';
      let item = {
        ROWID: 0,
        data: this.flatFileVersionHistoryItem,
      };
      let indexArrDialog = this.findDialog('mapperVersionSave_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerVersionSave() {
      let type = 'scannerVersionSave';
      let item = {
        ROWID: 0,
        data: this.scannerVersionHistoryItem,
      };
      let indexArrDialog = this.findDialog('scannerVersionSave_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    reFreshMapVersion() {
      this.$refs.mapperList?.[0]?.queryMapList();
    },
    reFreshScannerVersion() {
      this.$refs.scannerList?.[0]?.queryMapList();
    },
    closeScannerListDialog() {
      this.$refs.scannerList[0].removeDialog({});
      this.$refs.scannerVersion[0].removeDialog({});
    },
    closeMapperListDialog() {
      this.$refs.mapperList[0].removeDialog({});
      this.$refs.mapperVersion[0].removeDialog({});
    },
    selectCodeItem(item) {
      let listOb = Object.keys(this.$refs);
      if (listOb.includes('mapperBuilderCheckIn') && this.$refs.mapperBuilderCheckIn.length > 0) {
        this.$refs.mapperBuilderCheckIn[0].updateSelectCodeTitle(item);
      } else if (listOb.includes('mapper')) {
        this.$refs.mapper.updateSelectCode(item);
      }
    },
    changeType() {
      this.mapperCompo += 1;
      this.scannerCompo += 1;
    },
    changeMapperVersionHistoryItem(item) {
      this.flatFileVersionHistoryItem = item;
    },
    changeScannerVersionHistoryItem(item) {
      this.scannerVersionHistoryItem = item;
    },
    changeMap() {
      const query = this.$route.query;
      if (query.tab == 'Mapper') {
        this.tab = 1;
      } else {
        this.tab = 0;
      }
      if (query.mapId && query.tab == 'Mapper') {
        this.versionHistoryItems.data[0].MAP_PRCS_NO = query.mapId;
        Store.dispatch('map/queryMapperHistoryList', this.versionHistoryItems).then(() => {
          const currentItem = this.mapperList.find((e) => e.MAPP_VER == query.ver);

          const mapperItem = this.mapList.find((e) => e.MAP_PRCS_NO == query.mapId);

          currentItem.MAP_NAME = mapperItem.MAP_NAME;
          currentItem.MAP_CONV_TP = mapperItem.MAP_CONV_TP;
          currentItem.CODE_CTG_NAME = mapperItem.CODE_CTG_NAME;
          currentItem.SCANNER_NAME = mapperItem.SCANNER_NAME;
          currentItem.SCAN_VER = mapperItem.SCAN_VER;

          if (currentItem.CODE_CTG_ID) {
            this.getCodetables(currentItem.CODE_CTG_ID);
          }
          if (currentItem.MAP_CONV_TP.substring(0, 1) === 'E') {
            this.scannerType = 'ediscanner';
          } else if (currentItem.MAP_CONV_TP.substring(0, 1) === 'J') {
            this.scannerType = 'jsonscanner';
          } else if (currentItem.MAP_CONV_TP.substring(0, 1) === 'X') {
            this.scannerType = 'xmlscanner';
          } else if (currentItem.MAP_CONV_TP.substring(0, 1) === 'A') {
            this.scannerType = 'ediscanner_x12';
          } else {
            this.scannerType = 'FTE';
          }

          if (query.mapId && query.flag == 'Y') {
            Store.dispatch('common/viewFileData', currentItem.FILE_ID).then(() => {
              currentItem.fileContent = this.fileContent;
              this.$refs.mapper.updateMapper(currentItem);
              this.$refs.mapper.updateMapperStatus('Y');
            });
          }
          this.flatFileVersionHistoryItem = currentItem;

          if (currentItem.SCAN_VER && currentItem.SCANNER_NAME) {
            Store.dispatch('map/queryScannerHistoryList', this.versionHistoryItems).then(() => {
              const currentScannerItem = this.scannerList.find(
                (e) => e.SCAN_VER == currentItem.SCAN_VER
              );
              const scannerItem = this.mapList.find((e) => e.MAP_PRCS_NO == query.mapId);
              currentScannerItem.MAP_NAME = scannerItem.MAP_NAME;

              if (query.mapId && query.flag == 'Y') {
                Store.dispatch('common/viewFileData', currentScannerItem.FILE_ID).then(() => {
                  currentScannerItem.fileContent = this.fileContent;
                });
              }
              this.scannerVersionHistoryItem = currentScannerItem;
              this.pendingScannerItem = currentScannerItem;
            });
          }
        });
      }
      if (query.mapId && query.tab == 'Scanner') {
        this.versionHistoryItems.data[0].MAP_PRCS_NO = query.mapId;
        Store.dispatch('map/queryScannerHistoryList', this.versionHistoryItems).then(() => {
          const currentItem = this.scannerList.find((e) => e.SCAN_VER == query.ver);
          const mapperItem = this.mapList.find((e) => e.MAP_PRCS_NO == query.mapId);
          currentItem.MAP_NAME = mapperItem.MAP_NAME;

          this.scannerVersionHistoryItem = currentItem;

          if (query.mapId && query.flag == 'Y') {
            Store.dispatch('common/viewFileData', currentItem.FILE_ID).then(() => {
              currentItem.fileContent = this.fileContent;

              this.$refs.scanner.updateScanner(currentItem);
              this.$refs.scanner.updateScannerStatus('Y');
            });
          }
        });
      }
    },
  },
};
</script>

<style>
.type-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
}
.theme--light .type-text {
  color: #18236d;
}
.theme--dark .type-text {
  color: #bbbbbb;
}
.load-file-dialog {
  width: 1070px;
}
.theme--dark .page-header .v-input__control .v-input__slot {
  background-color: #2a2c35;
}
.theme--light .page-header .v-input__control .v-input__slot {
  background-color: #f3f5f7;
}
.mapbuilder-scanner-list {
  width: 888px !important;
  height: auto !important;
}
/* 2021.3.18 203728 CLV-769 Increase font size in all Editor of Map Builder */
.v-window__container .CodeMirror {
  font-size: 13px;
}
</style>
